import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST } from "../../actions";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isEmpty,
  showContaimerLoader,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "users/";
var moduleName = "Change Password";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.location.state?.editID || "";
    this.state = {
      editID: editID,
      userID: userID(),
      postdata: {
        userPassword: "",
        userOldPassword: "",
      },
      error_msg: "",
      pageloading: false,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }

  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      password: postData.userPassword,
      oldPassword: postData.userOldPassword,
      userID: this.state.userID,
    };

    var post_url = module + "updatepassword";
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="users" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { userOldPassword, userPassword } = props.fields;
  return {
    fields: ["userOldPassword", "userPassword"],
    validations: {
      userOldPassword: [[isEmpty, userOldPassword]],
      userPassword: [[isEmpty, userPassword]],
    },
  };
}

class PostForm extends Component {
  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsguserOldPassword,
      errMsguserPassword = "";

    if ($validation.userOldPassword.error.reason !== undefined) {
      errMsguserOldPassword = $validation.userOldPassword.show && (
        <span className="error">
          {$validation.userOldPassword.error.reason}
        </span>
      );
    }
    if ($validation.userPassword.error.reason !== undefined) {
      errMsguserPassword = $validation.userPassword.show && (
        <span className="error">{$validation.userPassword.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-4">
              <label className="form-label">
                Old Password
                <span className="lbl-error">*</span>
              </label>
              <div className="validate-input input-group" id="Password-toggle">
                <a
                  href={() => false}
                  className="input-group-text bg-white text-muted"
                >
                  <i
                    className="zmdi zmdi-eye text-muted"
                    aria-hidden="true"
                  ></i>
                </a>
                <input
                  className="input100 border-start-0 form-control ms-0"
                  type="password"
                  placeholder="Old Password"
                  value={fields.userOldPassword}
                  {...$field("userOldPassword", (e) =>
                    onChange("userOldPassword", e.target.value)
                  )}
                />
                {errMsguserOldPassword}
              </div>
            </div>
            <div className="form-group col-md-4">
              <label className="form-label">
                Password
                {this.props.editID === "" && (
                  <span className="lbl-error">*</span>
                )}
              </label>
              <div className="validate-input input-group" id="Password-toggle1">
                <a
                  href={() => false}
                  className="input-group-text bg-white text-muted"
                >
                  <i
                    className="zmdi zmdi-eye text-muted"
                    aria-hidden="true"
                  ></i>
                </a>
                <input
                  className="input100 border-start-0 form-control ms-0"
                  type="password"
                  placeholder="Password"
                  value={fields.userPassword}
                  {...$field("userPassword", (e) =>
                    onChange("userPassword", e.target.value)
                  )}
                />
                {errMsguserPassword}
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Update Password
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
